module.exports = __webpack_public_path__ + "v4assets/palo-alto.b0c15a6c84b1d5fac3f1a85b5f07b64b.png";